import type {
  AutomationSettings,
  AutomationTemplateId,
} from "@repo/app-types/entities/automation";
import { Input } from "@repo/ui/Inputs/input";
import type { FC } from "react";
import {
  type AutomationFieldsContext,
  AutomationSettingsFields,
} from "./automationSettingsFields.js";
import { ConfigurationField } from "./configurationField.js";

export interface AutomationConfigFormProps extends AutomationFieldsContext {
  templateId: AutomationTemplateId;
  name: string;
  settings: AutomationSettings;
  onNameChange: (name: string) => void;
  onSettingsChange: (settings: AutomationSettings) => void;
  onBlur?: () => void;
}

/**
 * The automation configuration editor. Fully controlled; the caller owns the
 * form state and commits it explicitly. `onBlur` lets the caller normalize a
 * field when it loses focus.
 *
 * Renders as a plain column rather than a card, so it continues the page
 * content column the template description above it already sits in.
 */
export const AutomationConfigForm: FC<AutomationConfigFormProps> = (props) => {
  const {
    templateId,
    name,
    settings,
    onNameChange,
    onSettingsChange,
    onBlur,
    ...fieldsContext
  } = props;
  return (
    <div className="flex w-full max-w-3xl flex-col gap-5">
      <h3 className="text-sm font-semibold text-foreground">Configuration</h3>

      <ConfigurationField label="Automation name">
        <div className="w-full sm:max-w-md">
          <Input
            value={name}
            isDisabled={fieldsContext.isReadOnly}
            onChange={(e) => {
              onNameChange(e.target.value);
            }}
            onBlur={onBlur}
          />
        </div>
      </ConfigurationField>

      <AutomationSettingsFields
        {...fieldsContext}
        templateId={templateId}
        settings={settings}
        onChange={onSettingsChange}
      />
    </div>
  );
};
